
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/les-innovations",
      function () {
        return require("private-next-pages/les-innovations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/les-innovations"])
      });
    }
  